import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Modal from '../../../components/ui/Modal';

const CompletionSummary = ({ formData, onClose }) => {
  return (
    <Modal 
      isOpen={true} 
      onClose={onClose} 
      size="large"
      title="Setup Complete!"
      description="Your AI agents are now configured and ready to help you achieve your marketing goals"
      icon={<Icon name="CheckCircle2" size={24} color="var(--color-success)" />}
      actions={null}
    >
      <div className="space-y-6">
        <div className="bg-muted/50 rounded-lg p-6 text-left space-y-4">
          <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
            <Icon name="FileCheck" size={20} color="var(--color-primary)" />
            Your Configuration Summary
          </h3>

          <div className="grid md:grid-cols-2 gap-4 text-sm">
            {formData?.companyName && (
              <div>
                <p className="text-muted-foreground">Company</p>
                <p className="font-medium text-foreground">{formData?.companyName}</p>
              </div>
            )}

            {formData?.industry && (
              <div>
                <p className="text-muted-foreground">Industry</p>
                <p className="font-medium text-foreground capitalize">
                  {formData?.industry?.replace('-', ' ')}
                </p>
              </div>
            )}

            {formData?.businessSize && (
              <div>
                <p className="text-muted-foreground">Business Size</p>
                <p className="font-medium text-foreground capitalize">{formData?.businessSize}</p>
              </div>
            )}

            {formData?.automationLevel && (
              <div>
                <p className="text-muted-foreground">Automation Level</p>
                <p className="font-medium text-foreground capitalize">
                  {formData?.automationLevel?.replace('-', ' ')}
                </p>
              </div>
            )}
          </div>

          {formData?.marketingObjectives && formData?.marketingObjectives?.length > 0 && (
            <div>
              <p className="text-muted-foreground mb-2">Marketing Objectives</p>
              <div className="flex flex-wrap gap-2">
                {formData?.marketingObjectives?.map((obj) => (
                  <span
                    key={obj}
                    className="px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium"
                  >
                    {obj?.replace('-', ' ')?.split(' ')?.map(w => w?.charAt(0)?.toUpperCase() + w?.slice(1))?.join(' ')}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="space-y-3">
          <div className="flex items-start gap-3 p-4 bg-primary/5 rounded-lg text-left">
            <Icon name="Zap" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-foreground mb-1">What happens next?</p>
              <ul className="text-muted-foreground space-y-1">
                <li>&bull; Marketing Agent will start discovering high-performing content for your industry</li>
                <li>&bull; Productivity Agent is ready to help you manage tasks and deadlines</li>
                <li>&bull; Feedback Agent will begin analyzing your performance metrics</li>
                <li>&bull; All agents are configured with your preferences and ready to assist</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <Button onClick={onClose} className="w-full md:w-auto px-8">
            Go to Dashboard
            <Icon name="ArrowRight" size={18} className="ml-2" />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CompletionSummary;